import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE
// boxiaotu主后端API（用于推广员注册）
const BOXIAOTU_API = 'https://api.boxiaotu.cn/api'


// 推广员类型配置
const PROMO_TYPES = {
  personal: { 
    name: '个人推广员', 
    color: '#13c2c2', 
    fee: '免费注册', 
    features: ['免费注册体验', 'AI动画类佣金30%', '线上课程佣金60%']
  },
  certified: { 
    name: '认证推广员', 
    color: '#722ed1', 
    fee: '¥5,000/年', 
    features: ['AI动画类佣金40%', '线上课程佣金80%', '可招募下线', '管理奖20%']
  },
  agency: { 
    name: '机构推广合伙人', 
    color: '#fa8c16', 
    fee: '¥5,000/年+SaaS', 
    features: ['AI动画类佣金50%', '线上课程佣金80%', '线下活动100%', '可招募下线']
  }
}

export default function PartnerApply() {
  const [promoType, setPromoType] = useState('personal')
  const [form, setForm] = useState({ name: '', phone: '', password: '', idCard: '', address: '' })
  const [loading, setLoading] = useState(false)
  const [result, setResult] = useState(null)
  const [error, setError] = useState('')
  
  // 从URL获取推荐人ID
  const [referrer, setReferrer] = useState('')
  const [referrerName, setReferrerName] = useState('')

  useEffect(() => {
    // 从URL参数获取推荐码
    const params = new URLSearchParams(window.location.search)
    const ref = params.get('ref') || params.get('referrer') || ''
    setReferrer(ref)
    
    // 如果有推荐码，获取推荐人信息
    if (ref) {
      fetchReferrerInfo(ref)
    }
  }, [])

  const fetchReferrerInfo = async (id) => {
    try {
      // 先检查是否是推广员
      const partnerRes = await fetch(`${BOXIAOTU_API}/partners/${id}`)
      const partnerData = await partnerRes.json()
      if (partnerData.success) {
        setReferrerName(partnerData.data.name + '（推广员）')
        return
      }
      
      // 检查是否是区域代理
      const agentRes = await fetch(`${BOXIAOTU_API}/regional-agents/${id}`)
      const agentData = await agentRes.json()
      if (agentData.success) {
        setReferrerName(agentData.data.name + '（区域代理）')
        return
      }
    } catch (e) {
      console.log('获取推荐人信息失败', e)
    }
  }

  const handleSubmit = async () => {
    if (!form.name.trim()) { setError('请输入姓名'); return }
    if (!form.phone.trim() || form.phone.length !== 11) { setError('请输入正确的手机号'); return }
    if (!form.password || form.password.length < 6) { setError('请输入至少6位密码'); return }
    
    setLoading(true)
    setError('')
    
    try {
      const res = await fetch(`${BOXIAOTU_API}/partners`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name,
          phone: form.phone,
          password: form.password,
          idCard: form.idCard,
          address: form.address,
          referrer: referrer,
          promoType: promoType
        })
      })
      
      const data = await res.json()
      
      if (data.success) {
        setResult({
          ...data.data,
          password: form.password,
          referrer_reward: data.data.agent_reward || 0
        })
      } else {
        setError(data.error || '提交失败')
      }
    } catch (e) {
      setError('网络错误，请重试')
    }
    setLoading(false)
  }

  // 申请成功
  if (result) {
    return (
      <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: '40px 20px' }}>
        <div style={{ maxWidth: 500, margin: '0 auto', background: '#fff', borderRadius: 16, padding: 32, textAlign: 'center' }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>🎉</div>
          <h2 style={{ fontSize: 24, color: '#52c41a', marginBottom: 8 }}>申请成功！</h2>
          <p style={{ color: '#666', marginBottom: 24 }}>恭喜您成为{PROMO_TYPES[promoType].name}</p>
          
          <div style={{ background: '#f6ffed', borderRadius: 12, padding: 20, marginBottom: 24, textAlign: 'left' }}>
            <div style={{ fontSize: 14, color: '#666', marginBottom: 12 }}>您的账号信息</div>
            <div style={{ display: 'grid', gap: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#999' }}>推广ID</span>
                <span style={{ fontWeight: 600, fontFamily: 'monospace' }}>{result.id}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#999' }}>登录密码</span>
                <span style={{ fontWeight: 600, fontFamily: 'monospace' }}>{result.password}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#999' }}>推广类型</span>
                <span style={{ fontWeight: 600, color: PROMO_TYPES[promoType].color }}>{result.level}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#999' }}>佣金比例</span>
                <span style={{ fontWeight: 600, color: '#52c41a' }}>{result.commission_rate}%</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: '#999' }}>体验期至</span>
                <span style={{ fontWeight: 600 }}>{new Date(result.expire_at).toLocaleDateString()}</span>
              </div>
            </div>
          </div>

          {result.referrer_reward > 0 && (
            <div style={{ background: '#fff7e6', borderRadius: 12, padding: 16, marginBottom: 24 }}>
              <div style={{ fontSize: 14, color: '#fa8c16' }}>
                🎁 推荐人已获得招募奖励：¥{result.referrer_reward}
              </div>
            </div>
          )}

          <div style={{ background: '#e6f7ff', borderRadius: 12, padding: 20, textAlign: 'left', marginBottom: 24 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#1890ff', marginBottom: 8 }}>您的推广链接</div>
            <div style={{ display: 'flex', gap: 8 }}>
              <input 
                type="text" 
                readOnly 
                value={`${window.location.origin}/partner/apply?ref=${result.id}`}
                style={{ flex: 1, padding: 10, border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 12 }}
              />
              <button 
                onClick={() => navigator.clipboard.writeText(`${window.location.origin}/partner/apply?ref=${result.id}`)}
                style={{ padding: '10px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, whiteSpace: 'nowrap' }}
              >
                复制
              </button>
            </div>
            <div style={{ fontSize: 11, color: '#999', marginTop: 8 }}>
              {PROMO_TYPES[promoType].features.includes('可招募下线') ? '分享此链接招募下线，下线卖课后您可获得20%管理奖' : '升级为认证推广员后可招募下线获得管理奖'}
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <button 
              onClick={() => {
                // 返回上一页或首页
                if (window.history.length > 1) {
                  window.history.back()
                } else {
                  window.location.href = '/cms/'
                }
              }}
              style={{ padding: 14, background: '#fff', border: '1px solid #ddd', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}
            >
              关闭页面
            </button>
            <button 
              onClick={() => {
                window.location.href = '/cms/?page=partner-center'
              }}
              style={{ padding: 14, background: '#667eea', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14 }}
            >
              进入推广中心
            </button>
          </div>
          <div style={{ fontSize: 11, color: '#999', marginTop: 12, textAlign: 'center' }}>
            保存好您的推广ID和密码！
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: '40px 20px' }}>
      <div style={{ maxWidth: 500, margin: '0 auto' }}>
        {/* 顶部导航栏 */}
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
          <button 
            onClick={() => window.history.back() || (window.location.href = '/cms/')}
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: '1px solid rgba(255,255,255,0.3)',
              color: '#fff',
              padding: '8px 16px',
              borderRadius: 20,
              cursor: 'pointer',
              fontSize: 13
            }}
          >
            ← 返回
          </button>
          <span style={{color:'#fff',fontSize:12,opacity:0.8}}>邀请他人申请</span>
          <button 
            onClick={() => {
              var l = window.location.origin + '/cms/?page=partner-apply';
              if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(l).then(() => alert('已复制到剪贴板！')).catch(() => prompt('复制此链接:', l));
              } else {
                prompt('复制此链接:', l);
              }
            }}
            style={{
              background: '#fff',
              border: 'none',
              color: '#667eea',
              padding: '8px 16px',
              borderRadius: 20,
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: 600
            }}
          >
            复制链接
          </button>
        </div>

        {/* 头部 */}
        <div style={{ textAlign: 'center', color: '#fff', marginBottom: 32 }}>
          <h1 style={{ fontSize: 28, marginBottom: 8 }}>🎋 博小兔推广员申请</h1>
          <p style={{ opacity: 0.9, fontSize: 14 }}>加入我们，一起推广优质课程</p>
        </div>

        {/* 推荐人提示 */}
        {referrerName && (
          <div style={{ background: '#fff', borderRadius: 12, padding: 16, marginBottom: 16, border: '2px solid #52c41a' }}>
            <div style={{ fontSize: 13, color: '#52c41a' }}>
              ✓ 推荐人：{referrerName}
            </div>
          </div>
        )}

        {/* 类型选择 */}
        <div style={{ background: '#fff', borderRadius: 16, padding: 24, marginBottom: 16 }}>
          <div style={{ fontSize: 14, color: '#666', marginBottom: 12 }}>选择推广身份</div>
          <div style={{ display: 'grid', gap: 12 }}>
            {Object.entries(PROMO_TYPES).map(([key, info]) => (
              <div
                key={key}
                onClick={() => setPromoType(key)}
                style={{
                  padding: 16,
                  border: '2px solid',
                  borderColor: promoType === key ? info.color : '#e8e8e8',
                  background: promoType === key ? `${info.color}11` : '#fff',
                  borderRadius: 12,
                  cursor: 'pointer'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <span style={{ fontSize: 16, fontWeight: 600, color: promoType === key ? info.color : '#333' }}>
                    {info.name}
                  </span>
                  <span style={{ 
                    padding: '4px 12px', 
                    background: info.color, 
                    color: '#fff', 
                    borderRadius: 20, 
                    fontSize: 12 
                  }}>
                    {info.fee}
                  </span>
                </div>
                <div style={{ fontSize: 12, color: '#666' }}>
                  {info.features.map((f, i) => (
                    <span key={i} style={{ marginRight: 12 }}>• {f}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 申请表单 */}
        <div style={{ background: '#fff', borderRadius: 16, padding: 24 }}>
          <div style={{ fontSize: 14, color: '#666', marginBottom: 16 }}>填写申请信息</div>
          
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, color: '#666', marginBottom: 6 }}>姓名 *</label>
            <input 
              type="text"
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
              placeholder="请输入真实姓名"
              style={{ width: '100%', padding: 14, border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, color: '#666', marginBottom: 6 }}>手机号 *</label>
            <input 
              type="tel"
              value={form.phone}
              onChange={e => setForm({ ...form, phone: e.target.value })}
              placeholder="请输入手机号"
              maxLength={11}
              style={{ width: '100%', padding: 14, border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, color: '#666', marginBottom: 6 }}>登录密码 *</label>
            <input 
              type="password"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              placeholder="请设置登录密码（至少6位）"
              minLength={6}
              style={{ width: '100%', padding: 14, border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, color: '#666', marginBottom: 6 }}>身份证号（选填）</label>
            <input 
              type="text"
              value={form.idCard}
              onChange={e => setForm({ ...form, idCard: e.target.value })}
              placeholder="选填，用于实名认证"
              style={{ width: '100%', padding: 14, border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 13, color: '#666', marginBottom: 6 }}>地址（选填）</label>
            <input 
              type="text"
              value={form.address}
              onChange={e => setForm({ ...form, address: e.target.value })}
              placeholder="选填"
              style={{ width: '100%', padding: 14, border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
            />
          </div>

          {error && (
            <div style={{ padding: 12, background: '#fff1f0', color: '#f5222d', borderRadius: 8, marginBottom: 16, fontSize: 13 }}>
              {error}
            </div>
          )}

          <button 
            onClick={handleSubmit}
            disabled={loading}
            style={{ 
              width: '100%', 
              padding: 16, 
              background: PROMO_TYPES[promoType].color, 
              color: '#fff', 
              border: 'none', 
              borderRadius: 8, 
              fontSize: 16, 
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1 
            }}
          >
            {loading ? '提交中...' : '立即申请'}
          </button>
        </div>

        {/* 说明 */}
        <div style={{ marginTop: 24, color: '#fff', opacity: 0.8, fontSize: 12, textAlign: 'center' }}>
          <p>申请成功后可获得7天免费体验期</p>
          <p>有问题请联系客服</p>
        </div>
      </div>
    </div>
  )
}
